// Home Vuex

import state from './configurationStates.js'
import * as getters from './configurationGetters.js'
import * as mutations from './configurationMutations.js'
import * as actions from './configurationActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
